// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 808 ? "d0dec1b0" : chunkId) + "." + {"609":"e59cb6f7367e2c62","808":"f0e4f5b67052cd7b"}[chunkId] + ".js";
};